module.exports = __webpack_public_path__ + "static/media/6COPUOS4.8543d09c.jpg";